export default __webpack_public_path__ + "static/media/nilByMouthIcon.c1b2d983.svg";